module.exports = __webpack_public_path__ + "media/images/shark/Tilden-ae315163769abb64b4660d2f3b81d289.jpg";